/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DataMappingFromJSON, DataMappingToJSON } from './';
export function CreateDataMappingRequestFromJSON(json) {
    return CreateDataMappingRequestFromJSONTyped(json, false);
}
export function CreateDataMappingRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        flag: json['flag'],
        dataMapping: DataMappingFromJSON(json['dataMapping']),
    };
}
export function CreateDataMappingRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        flag: value.flag,
        dataMapping: DataMappingToJSON(value.dataMapping),
    };
}
